// extracted by mini-css-extract-plugin
export var black = "_2t-6";
export var brand = "_2t-1";
export var ddefault = "_2t-0";
export var error = "_2t-3";
export var gray = "_2t-2";
export var highContrast = "_2t-8";
export var outline = "_2t-7";
export var success = "_2t-5";
export var warning = "_2t-4";